<template>
  <div class="page">
    <TopBar />
    <div class="login-container">
      <div class="login-panel">
        <div class="panel-header">
          <span class="panel-title">AUTHENTICATE</span>
        </div>
        <div class="panel-body">
          <form @submit.prevent="submit">
            <div class="field">
              <label class="field-label">EMAIL</label>
              <input
                v-model="form.email"
                type="email"
                autocomplete="email"
                class="field-input"
                placeholder="you@example.com"
              />
            </div>
            <div class="field">
              <label class="field-label">PASSWORD</label>
              <input
                v-model="form.password"
                type="password"
                autocomplete="current-password"
                class="field-input"
                placeholder="••••••••"
              />
            </div>
            <div v-if="errors.length" class="errors">
              <p v-for="error in errors" :key="error" class="error-text">{{ error }}</p>
            </div>
            <button type="submit" class="submit-btn" :disabled="submitting">
              {{ submitting ? "AUTHENTICATING..." : "SIGN IN" }}
            </button>
          </form>
        </div>
      </div>
    </div>
    <div class="bg-grid" />
  </div>
</template>

<script setup>
import { ref } from "vue"
import { router } from "@inertiajs/vue3"
import TopBar from "../../components/TopBar.vue"

const props = defineProps({
  errors: {
    type: Array,
    default: () => [],
  },
})

const form = ref({ email: "", password: "" })
const submitting = ref(false)

function submit() {
  submitting.value = true
  router.post("/users/sign_in", {
    user: { email: form.value.email, password: form.value.password },
  }, {
    onFinish: () => { submitting.value = false },
  })
}
</script>

<style scoped>
.page {
  min-height: 100vh;
  background-color: #0a0a0b;
  position: relative;
}

.bg-grid {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 0;
  background-image:
    linear-gradient(rgba(245, 166, 35, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(245, 166, 35, 0.03) 1px, transparent 1px);
  background-size: 40px 40px;
}

.login-container {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 58px);
}

.login-panel {
  width: 100%;
  max-width: 400px;
  background: rgba(255, 255, 255, 0.025);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  margin: 24px;
}

.panel-header {
  padding: 14px 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.panel-title {
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.2px;
  color: rgba(232, 230, 227, 0.45);
}

.panel-body {
  padding: 24px 18px;
}

.field {
  margin-bottom: 16px;
}

.field-label {
  display: block;
  font-family: var(--font-mono);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 1.2px;
  color: rgba(232, 230, 227, 0.45);
  margin-bottom: 6px;
}

.field-input {
  width: 100%;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 4px;
  padding: 10px 12px;
  font-family: var(--font-mono);
  font-size: 12px;
  color: #e8e6e3;
  outline: none;
  transition: border-color 0.15s;
}

.field-input:focus {
  border-color: rgba(245, 166, 35, 0.4);
}

.field-input::placeholder {
  color: rgba(232, 230, 227, 0.25);
}

.errors {
  margin-bottom: 14px;
}

.error-text {
  font-family: var(--font-mono);
  font-size: 11px;
  color: #f87171;
  margin: 4px 0;
}

.submit-btn {
  width: 100%;
  padding: 11px;
  background: #f5a623;
  border: none;
  border-radius: 4px;
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.2px;
  color: #0a0a0b;
  cursor: pointer;
  transition: opacity 0.2s;
  margin-top: 8px;
}

.submit-btn:hover:not(:disabled) {
  opacity: 0.9;
}

.submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
